<template>
  <v-dialog v-model="show_modal" persistent max-width="800">
    <v-card>
      <v-card-title>
        ตั้งค่าหน่วยกิตวิชาวิทยานิพนธ์ (ลบ) <br />
        {{ level == 2 ? "ระดับปริญญาโท" : "ระดับปริญญาเอก" }}
      </v-card-title>
      <v-card-text>
        ต้องการลบข้อมูล<br /><br />
        <v-chip color="black" dark class="mr-2"> {{ name_faculty }} </v-chip>
        <v-chip color="gray" class="mr-2"> {{ name_curriculum }} </v-chip>
        <br />
        <v-chip color="orange" dark class="mr-2">
          ปีรับเข้า {{ admis_term }}/{{ admis_year }}
        </v-chip>
        <v-chip color="blue" dark> แผนการเรียน : {{ name_study_plan }} </v-chip>
        <br />
        <v-chip color="green" dark>
          รหัสวิชา {{ subject_id }} -<span
            :style="{
              color:
                subject_type === 'T'
                  ? 'blue'
                  : subject_type === 'S'
                  ? 'yellow'
                  : 'red',
              fontWeight: 'bold',
            }"
          >
            {{ subject_type }} </span
          >- {{ subject_name }} </v-chip
        ><br /><br />
        หรือไม่ ?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark @click="delete_modal()">
          {{ $t("config_academic.confirm") }}</v-btn
        >
        <v-btn color="error" dark @click="show_modal = false">{{
          $t("config_academic.cancel")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ConfigProvider from "@/services/config.provider";
const configService = new ConfigProvider();

export default {
  name: "ConfigGraduateSeparateThesisCreditDeleteDialog",

  props: {
    toggle_loading: Function,
    fetch_data: Function,
  },

  data: () => ({
    show_modal: false,

    level: null,
    faculty_id: null,
    curriculum_id: null,
    admis_year: null,
    admis_term: null,
    study_plan_id: null,
    prog_id: null,
    sub_prog_id: null,
    name_faculty: null,
    name_curriculum: null,
    name_study_plan: null,
    subject_id: null,
    subject_name: null,
    subject_type: null,
  }),

  computed: {},

  methods: {
    open_delete_modal: function (
      selected_level,
      selected_faculty_id,
      selected_curriculum_id,
      selected_year,
      selected_semester,
      selected_study_plan_id,
      name_faculty,
      name_curriculum,
      item
    ) {
      this.show_modal = true;

      this.level = selected_level;
      this.faculty_id = selected_faculty_id;
      this.curriculum_id = selected_curriculum_id;
      this.admis_year = selected_year;
      this.admis_term = selected_semester;
      this.study_plan_id = selected_study_plan_id;

      this.name_faculty = name_faculty;
      this.name_curriculum = name_curriculum;
      this.prog_id = item.prog_id;
      this.sub_prog_id = item.sub_prog_id;
      this.name_study_plan = item.study_plan_name;
      this.subject_id = item.subject_id;
      this.subject_name = item.subject_name;
      this.subject_type = item.subject_type;
    },

    delete_modal: async function () {
      this.toggle_loading(true);
      let response = await configService
        .deleteGraduateSeparateThesisCredit({
          faculty_id: this.faculty_id,
          curr_id: this.curriculum_id,
          admis_year: this.admis_year,
          admis_term: this.admis_term,
          prog_id: this.prog_id,
          sub_prog_id: this.sub_prog_id,
          subject_id: this.subject_id,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.toggle_loading(false);
        });
      this.show_modal = false;
      this.fetch_data();
      if (response && response.status)
        this.$toasted.success(this.$t("toasted.delete_successfully"));
      else {
        this.$toasted.error(this.$t("toasted.cannot_delete"), {
          duration: 0,
        });
      }
    },
  },
};
</script>
